export default __webpack_public_path__ + "static/media/cross.c45622cd.svg";